import { render, staticRenderFns } from "./sideView.vue?vue&type=template&id=f8156a44&scoped=true&"
import script from "./sideView.vue?vue&type=script&lang=js&"
export * from "./sideView.vue?vue&type=script&lang=js&"
import style0 from "./sideView.vue?vue&type=style&index=0&id=f8156a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8156a44",
  null
  
)

export default component.exports